module.exports = "/_next/static/images/first-home-desktop-96e4546af100aed90643c94e637d158c.svg";